// Parçalı Ödeme penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.partialPayment';

export const partialPaymentGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Parçalı ödeme nasıl alınır?'),
  intro: t(`${G}.intro`, 'Bu pencere, bir satışın tutarını nakit ve POS gibi birden fazla ödemeye bölmenizi sağlar. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Toplamlar'),
    body: t(`${G}.regions.body`, 'Ödemeler ve tuş takımı'),
    footer: t(`${G}.regions.footer`, 'İptal / Tamamla'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Toplamları izleyin'),
      text: t(`${G}.s1.text`, 'Üstte TOPLAM TUTAR, ÖDENEN TUTAR, KALAN TUTAR ve BELGE DURUMU görünür. Kalan tutar sıfıra inince satış tamamlanabilir. Fazla ödeme girerseniz kalan eksiye düşer ve "(Para Üstü)" yazar.'),
      tips: [
        t(`${G}.s1.tip1`, 'BELGE DURUMU "AÇIK" ise yazarkasada bu satış için bir fiş açıktır; o fiş kapatılmadan veya iptal edilmeden pencere kapanmaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Ödeme ekleyin'),
      text: t(`${G}.s2.text`, 'Sağda bir ödeme türü seçin (nakit, POS düğmeleri, açıksa açık hesap), tuş takımıyla tutarı yazın ve Enter\'a basın. Ödeme soldaki "Ödeme Yöntemleri" listesine eklenir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Kalan tutarın tamamını tek seferde girerseniz ödeme hemen alınır ve satış tamamlanır (hızlı mod).'),
        t(`${G}.s2.tip2`, 'Kısmi bir tutar girerseniz yazarkasada fiş açılır (BELGE DURUMU: AÇIK). Beko cihazlarda ve Rest-P2P modunda fiş açılmaz; ödemeler birikir ve sonunda birlikte gönderilir.'),
        t(`${G}.s2.tip3`, 'Açık hesap düğmesi genel müşteri seçiliyken pasiftir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Fiş açıkken ödemeleri tek tek alın'),
      text: t(`${G}.s3.text`, 'Fiş açıkken her ödemenin yanında "💳 Ödeme Ekle" çıkar. Basınca o ödeme yazarkasaya gönderilir; POS ise kart okutulur. Başarılı ödeme "✓ Ödendi" olur.'),
      tips: [
        t(`${G}.s3.tip1`, 'Ingenico 5000F\'de "Ödeme Hatası — Cihaz Durumu Doğrulanamadı" çıkarsa yazarkasa ekranına ve POS slibine bakın. Para alındıysa "Yine de Devam Et (Ödeme Alındı)", alınmadıysa "İptal (Ödeme Alınmadı)" deyip tekrar deneyin.'),
        t(`${G}.s3.tip2`, 'Para alınmadığı halde "Yine de Devam Et" derseniz eksik tahsilatla satış kapanır; alındığı halde tekrar denerseniz müşteriden iki kez ödeme alınabilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Ödeme silme ve iade'),
      text: t(`${G}.s4.text`, 'Henüz cihaza gönderilmemiş (Bekliyor) bir ödemeyi çöp kutusu simgesiyle silebilirsiniz; para hareketi oluşmaz. "✓ Ödendi" bir ödemeyi geri almak için "↩️ İade" kullanılır (Hugin ve Ingenico); ödeme cihazda geri alınır ve "İade Edildi" olur.'),
      tips: [
        t(`${G}.s4.tip1`, 'Fiş kapandıktan sonra iade edilmiş POS ödemeleri varsa "Gerçek POS İadesi Gerekli" penceresi açılır. "İade İşlemini Başlat" ile karta iadeyi yapın; başarısız olursa POS terminalinden, gösterilen Auth Code ile elle iade edin.'),
        t(`${G}.s4.tip2`, '"Sonra Yap (Manuel)" iadeyi yapmadan pencereyi kapatır; karta iadeyi daha sonra sizin yapmanız gerekir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Tamamlayın veya iptal edin'),
      text: t(`${G}.s5.text`, 'Fiş açıksa ve bekleyen ödeme kalmadıysa "🔒 Belgeyi Kapat & Tamamla" ile bitirin (PavoPay\'de son ödemeyle fiş kendiliğinden kapanır). Fiş açılmadıysa "Ödemeyi Tamamla (Hızlı)" kullanılır. Ardından satış sisteme kaydedilir: stok düşer, nakit kısmı nakit kasaya, POS kısmı POS\'un banka hesabına işlenir.'),
      tips: [
        t(`${G}.s5.tip1`, '"❌ Belgeyi İptal Et": alınmış ödeme yoksa yazarkasadaki açık fişi iptal eder ve tüm ödemeleri siler; geri alınamaz. Alınmış ödeme varsa önce "↩️ İade" ile iade edin (Ingenico\'da cihaz resetlendiyse "Zorla İptal Et").'),
        t(`${G}.s5.tip2`, '"İptal" pencereyi kapatır, satış kaydedilmez. Henüz gönderilmemiş ödemeler bu ekran için saklanır ve pencereyi yeniden açınca geri gelir.'),
        t(`${G}.s5.tip3`, 'Pencere açılırken yazarkasaya bağlanılamazsa "Yazarkasa Bağlı Değil" sorulur. "Yazarkasasız Devam Et" derseniz satış fişsiz kaydedilir.'),
      ],
    },
  ],
});
